<template>
    <div class="copy-right">
        <p>
            <a :href="BEIAN_WEBSITE" target="_blank">{{ ICP_NO }}-{{ DOMAIN_INDEX }}</a>
        </p>
    </div>
</template>
<script lang="ts" setup>
const ICP_NO = process.env.VUE_APP_ICP_NO;
const DOMAIN_INDEX = process.env.VUE_APP_ICP_INDEX;
const BEIAN_WEBSITE = process.env.VUE_APP_BEIAN_WEBSITE;
</script>
<style lang="scss" scoped>
$f16: 16px;
$f12: 12px;
.copy-right {
    width: 100%;
    text-align: center;
    padding: $f16 * 0.75 0;
    background-color: white;
    font-size: $f12;
    color: #666;
    a {
        color: #666;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
